// removed by extract-text-webpack-plugin
module.exports = {"page":"wmf-3ziMZvlj","rowname":"wmf-1-Ez_LGW","contents":"wmf-k_e3AhyJ","required":"wmf-1J18sgh0","publicspan":"wmf-3l7nXNcK","content":"wmf-1-ygNDXP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/newcomplaintinformationinquiry/complaint-information-inquiry.module.less
// module id = 1070
// module chunks = 0